// This file was automatically generated from ptdata.model.medOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.medOrder');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.core');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.typeSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isSurescripts) ? 'Downloaded' : (opt_data.isDocumentMed) ? 'Doc\'d' + ((opt_data.displayType) ? ' ' + soy.$$escapeHtml(opt_data.displayType) : '') : (opt_data.isERx) ? 'eRx ' + soy.$$escapeHtml(opt_data.displayType) : soy.$$escapeHtml(opt_data.displayType));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.displayQuantity = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.wordy) ? ((opt_data.quantity) ? soy.$$escapeHtml(opt_data.quantity) + ' (' + (soy.$$escapeHtml(opt_data.quantity)? el8.util.string.intToWords(soy.$$escapeHtml(opt_data.quantity)) : '') + ')' : '\'\'') + ((opt_data.quantityUnits) ? ' ' + soy.$$escapeHtml(opt_data.quantityUnits) : ' (units not specified)') : soy.$$escapeHtml(opt_data.quantity ? opt_data.quantity : '') + ((opt_data.quantityUnits) ? ' ' + soy.$$escapeHtml(opt_data.quantityUnits) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.substitutionsInstr = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isAllowSubstitutions == false) ? ' Do NOT substitute - DAW.' : (opt_data.isAllowSubstitutions == true) ? (opt_data.wordy) ? ' Substitutions allowed.' : '' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.chartFeedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumentMed) ? '<div class="el8FeedItemIconDocMed"></div>' : '<div class="el8FeedItemIconRx"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.chartFeedIconNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.displayType == 'Refill') ? '<div class="el8ChartFeedIconRefillMed"></div>' : (opt_data.displayType == 'Change') ? '<div class="el8ChartFeedIconChangeMed"></div>' : '<div class="el8ChartFeedIconMed"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.baseSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName), (opt_data.directions) ? ' ' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.directions)) : soy.$$escapeHtml(opt_data.directions)) : soy.$$escapeHtml(opt_data.directions)) : '');
  if (opt_data.quantity || opt_data.quantityUnits) {
    output.append(' #');
    el8.template.ptdata.model.medOrder.displayQuantity(opt_data, output);
  }
  output.append((opt_data.authRefills != null) ? ' RFx' + soy.$$escapeHtml(opt_data.authRefills) : '', (opt_data.numSamples) ? ' Samples: ' + soy.$$escapeHtml(opt_data.numSamples) : '', (opt_data.indication) ? ' [for ' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.indication)) : soy.$$escapeHtml(opt_data.indication)) : soy.$$escapeHtml(opt_data.indication)) + ']' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.otherPrescriberSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumentMed && opt_data.documentedOtherPrescriberName) ? ' <span class="el8AppColor">(' + soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) + ')</span>' : (opt_data.isRxDownload) ? ' <span class="el8AppColor">(' + ((opt_data.rxDownloadPrescriberName) ? soy.$$escapeHtml(opt_data.rxDownloadPrescriberName) : 'Prescriber Unknown') + ')</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.otherPrescriberSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumentMed && opt_data.documentedOtherPrescriberName) ? ' TODO: doc\'d other rx\'er: ' + soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) : (opt_data.isRxDownload) ? ' TODO: download rx\'er: (' + ((opt_data.rxDownloadPrescriberName) ? soy.$$escapeHtml(opt_data.rxDownloadPrescriberName) : 'Prescriber Unknown') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.writtenBySummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (! opt_data.isRxDownload) {
    output.append('<span class="el8SystemText leftIndent">-- ');
    if (opt_data.isDocumentMed) {
      output.append('documented by ', soy.$$escapeHtml(opt_data.documentingPersonnelName), (opt_data.displayDocumentedByDate) ? ' on ' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') : '');
    } else if (opt_data.signUserBehalfName) {
      el8.template.render.signOff.summaryText(opt_data, output);
    } else {
      output.append(soy.$$escapeHtml(opt_data.rxPrescriberName));
    }
    output.append((opt_data.supervisingPhysicianName) ? ' - Supervisor: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '', '</span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.writtenBySummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.isRxDownload) ? '<div class="el8FeedColSourceTopLine">' + ((opt_data.isDocumentMed && opt_data.documentedOtherPrescriberName) ? soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) : (opt_data.signUserBehalfName) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName)) : (opt_data.rxPrescriberName) ? soy.$$escapeHtml(opt_data.rxPrescriberName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.signUserName)) : soy.$$escapeHtml(opt_data.signUserName))) + '</div><div class="el8FeedColSourceLine">' + ((opt_data.signUserBehalfName) ? soy.$$escapeHtml(opt_data.signUserBehalfName) : (opt_data.isDocumentMed) ? 'Doc\'d by ' + soy.$$escapeHtml(opt_data.documentingPersonnelName) + ((opt_data.displayDocumentedByDate) ? ' on ' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') : '') : (opt_data.supervisingPhysicianName) ? 'Superv: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.pharmacyInstructionsSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.substitutionsInstr(opt_data, output);
  output.append((opt_data.pharmacyInstructions) ? ' <span class="el8AppColor">Instr:</span>' + ((opt_data.pharmacyInstructions) ? ' ' + soy.$$escapeHtml(opt_data.pharmacyInstructions) : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.pharmacyInstructionsSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isAllowSubstitutions) {
    el8.template.ptdata.model.medOrder.substitutionsInstr(opt_data, output);
  }
  output.append((opt_data.pharmacyInstructions) ? ' Instr:' + ((opt_data.pharmacyInstructions) ? ' ' + soy.$$escapeHtml(opt_data.pharmacyInstructions) : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isCancelIgnored) ? '(Cancellation requested, no response)&nbsp;' : (opt_data.isCancelSent) ? '(Cancellation sent to pharmacy)&nbsp;' : (opt_data.isCancelPending) ? '(Canceling...)&nbsp;' : (opt_data.isCanceled) ? '(Canceled)&nbsp;' : '', soy.$$escapeHtml(opt_data.displayedMedicationName), (opt_data.directions) ? ' sig: ' + soy.$$escapeHtml(opt_data.directions) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.refPanelSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isCancelIgnored) ? '<span class="el8TagItem el8MakeTagFinished mr5">Cancellation requested, no response</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelSent) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Cancellation sent to pharmacy</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelPending) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Canceling...</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelDenied) ? '<span class="el8TagItem el8MakeTagFinished mr5">Unable to cancel</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCanceled) ? '<span class="el8TagItem el8MakeTagFinished mr5">Canceled</span><span style="font-size: 0">&nbsp;</span><span class="el8Strike">' : (opt_data.isChanged && ! opt_data.isChangeDenied) ? '<span class="el8TagItem mr5">Changed per pharmacy</span><span style="font-size: 0">&nbsp;</span>' : '', '<span class="el8TagItem mr5">');
  el8.template.ptdata.model.medOrder.typeSummary(opt_data, output);
  output.append('</span><span style="font-size: 0">&nbsp;</span>', (opt_data.hasTrigger) ? '<a class="details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' : '');
  el8.template.ptdata.model.medOrder.baseSummary(opt_data, output);
  output.append((opt_data.hasTrigger) ? '</a>' : '', (opt_data.isCanceled) ? '</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.orderDetailedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.signDate) ? '<span class="el8GenTagItem el8TagItem mr5">In Progress</span>' : '');
  if (opt_data.isRxDownload) {
    el8.template.core.newTag(null, output);
  }
  output.append((opt_data.isCancelIgnored) ? '<span class="el8TagItem el8MakeTagFinished mr5">Cancellation requested, no response</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelSent) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Cancellation sent to pharmacy</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelPending) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Canceling...</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCanceled) ? '<span class="el8TagItem el8MakeTagFinished mr5">Canceled</span><span style="font-size: 0">&nbsp;</span><span class="el8Strike">' : (opt_data.isCancelDenied) ? '<span class="el8TagItem el8MakeTagFinished mr5">Unable to cancel</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isChanged && ! opt_data.isChangeDenied) ? '<span class="el8TagItem mr5">Changed per pharmacy</span><span style="font-size: 0">&nbsp;</span>' : '', '<span class="el8TagItem mr5">');
  el8.template.ptdata.model.medOrder.typeSummary(opt_data, output);
  output.append('</span><span style="font-size: 0">&nbsp;</span>', (opt_data.feedItemId) ? '<a class="' + ((opt_data.signDate) ? 'details-trigger' : 'unsigned-order-trigger') + '" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' : (opt_data.hasTrigger) ? '<a class="details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' : '');
  el8.template.ptdata.model.medOrder.baseSummary(opt_data, output);
  el8.template.ptdata.model.medOrder.pharmacyInstructionsSummary(opt_data, output);
  output.append((opt_data.feedItemId || opt_data.hasTrigger) ? '</a>' : '', (opt_data.isCanceled) ? '</span>' : '');
  el8.template.ptdata.model.medOrder.otherPrescriberSummary(opt_data, output);
  output.append((! opt_data.includeStartDate && opt_data.isPostDated) ? ' (to start on: ' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') + ')' : (opt_data.includeStartDate) ? ' (start on: ' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8FeedItemHeader">');
  el8.template.ptdata.model.medOrder.orderDetailedSummary(soy.$$augmentData(opt_data, {includeStartDate: ! opt_data.isWrittenOnStartDate}), output);
  el8.template.ptdata.model.medOrder.writtenBySummary(opt_data, output);
  output.append('</p>');
  if (opt_data.latestExternalFulfillment && opt_data.signDate) {
    el8.template.ptdata.model.medOrder.fulfillment(opt_data.latestExternalFulfillment, output);
  }
  output.append((opt_data.notes) ? '<p class="el8AppColor">Note: ' + soy.$$escapeHtml(opt_data.notes) + '</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.orderDetailedSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.signDate) ? 'In Progress: ' : '');
  if (opt_data.isRxDownload) {
    el8.template.core.newTag(null, output);
  }
  output.append((opt_data.feedItemId) ? '<a class="el8FeedItemColMainTopLineLink el8BreakWord ' + ((opt_data.signDate) ? 'details-trigger' : 'unsigned-order-trigger') + '" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' : (opt_data.hasTrigger) ? '<a class="el8FeedItemColMainTopLineLink el8BreakWord details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' : '', (opt_data.isCancelIgnored) ? '<span class="el8TagItem el8MakeTagFinished mr5">Cancellation requested, no response</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelSent) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Cancellation sent to pharmacy</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCancelPending) ? '<span class="el8TagItem el8MakeTagInProgress mr5">Canceling...</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isCanceled) ? '<span class="el8TagItem el8MakeTagFinished mr5">Canceled</span><span style="font-size: 0">&nbsp;</span><span class="el8Strike el8999">' : (opt_data.isCancelDenied) ? '<span class="el8TagItem el8MakeTagFinished mr5">Unable to cancel</span><span style="font-size: 0">&nbsp;</span>' : (opt_data.isChanged && ! opt_data.isChangeDenied) ? '<span class="el8TagItem mr5">Changed per pharmacy</span><span style="font-size: 0">&nbsp;</span>' : '');
  el8.template.ptdata.model.medOrder.typeSummary(opt_data, output);
  output.append(': ');
  el8.template.ptdata.model.medOrder.baseSummary(opt_data, output);
  output.append((opt_data.isCanceled) ? '</span>' : '', (opt_data.feedItemId || opt_data.hasTrigger) ? '</a>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.feedSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColMainTopLine">');
  el8.template.ptdata.model.medOrder.orderDetailedSummaryNew(soy.$$augmentData(opt_data, {includeStartDate: ! opt_data.isWrittenOnStartDate}), output);
  output.append('</div>');
  if (opt_data.latestExternalFulfillment && opt_data.signDate) {
    output.append('<div class="mv3">');
    el8.template.ptdata.model.medOrder.fulfillment(opt_data.latestExternalFulfillment, output);
    output.append('</div>');
  }
  output.append((opt_data.notes) ? '<div class="el8FeedColMainLine">Note: ' + soy.$$escapeHtml(opt_data.notes) + '</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.medsHxSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>');
  el8.template.ptdata.model.medOrder.orderDetailedSummary(opt_data, output);
  el8.template.ptdata.model.medOrder.writtenBySummary(opt_data, output);
  output.append('</p>');
  if (opt_data.latestExternalFulfillment && opt_data.signDate) {
    output.append('<p>');
    el8.template.ptdata.model.medOrder.fulfillment(opt_data.latestExternalFulfillment, output);
    output.append('</p>');
  }
  output.append((opt_data.notes) ? '<p class="el8AppColor">Note: ' + soy.$$escapeHtml(opt_data.notes) + '</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.prescriptionSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8StandardFontSize" style="border-radius:4px;padding:16px;border:1px solid #E0E8EA;flex:1;line-height:17px;">');
  el8.template.ptdata.model.medOrder.prescriptionSummaryBase(opt_data, output);
  output.append((opt_data.prescription.modelClass == 'MedOrder') ? '<div class="mt10 el8Italic">Received on ' + (soy.$$escapeHtml(opt_data.prescription.fulfillmentTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.prescription.fulfillmentTime)) : '') + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.prescriptionSummaryBase = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><span class="el8TagItem mr5">');
  el8.template.ptdata.model.medOrder.typeSummary({isSurescripts: opt_data.prescription.isSurescripts, isDocumentMed: opt_data.prescription.isDocumentMed, isERx: opt_data.prescription.isERx, displayType: opt_data.prescription.displayType}, output);
  output.append('</span>', (opt_data.prescription.modelClass == 'MedOrder') ? '<a class="details-trigger" _fid="MedOrder_' + soy.$$escapeHtml(opt_data.prescription.id) + '"><span class="el8Bold ' + ((opt_data.highlightMap && opt_data.highlightMap.displayedMedicationName) ? 'el8Highlighted' : '') + '">' + soy.$$escapeHtml(opt_data.prescription.displayedMedicationName) + '</span></a>' : '<span class="el8Bold ' + ((opt_data.highlightMap && opt_data.highlightMap.displayedMedicationName) ? 'el8Highlighted' : '') + '">' + soy.$$escapeHtml(opt_data.prescription.displayedMedicationName) + '</span>', '</div>', (opt_data.prescription.directions) ? '<div><span class="' + ((opt_data.highlightMap && opt_data.highlightMap.directions) ? 'el8Highlighted' : '') + '">Sig: ' + soy.$$escapeHtml(opt_data.prescription.directions) + '</span></div>' : '', '<div><span class="', (opt_data.highlightMap && opt_data.highlightMap.quantity) ? 'el8Highlighted' : '', '">Qty: ', soy.$$escapeHtml(opt_data.prescription.quantity ? opt_data.prescription.quantity : '0'), '</span>', (opt_data.prescription.quantityUnits) ? ' <span class="' + ((opt_data.highlightMap && opt_data.highlightMap.quantityUnits) ? 'el8Highlighted' : '') + '">' + soy.$$escapeHtml(opt_data.prescription.quantityUnits) : '', '</span>, <span class="', (opt_data.highlightMap && opt_data.highlightMap.authRefills) ? 'el8Highlighted' : '', '">Refills: ', soy.$$escapeHtml(opt_data.prescription.authRefills != null ? opt_data.prescription.authRefills : '0'), '</span></div>', (opt_data.prescription.numSamples) ? '<div>Samples: ' + soy.$$escapeHtml(opt_data.prescription.numSamples) + '</div>' : '', (opt_data.prescription.indication) ? '<div>[for ' + soy.$$escapeHtml(opt_data.prescription.indication) + ']</div>' : '', (opt_data.prescription.isAllowSubstitutions) ? '<div>Dispense as written (Do not substitute)</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.fulfillments = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (! opt_data.fulfillments) {
    output.append((opt_data.fulfillmentRequired) ? '<p class="el8AppColor">Prescription not ePrescribed or printed.</p>' : '');
  } else {
    output.append('<ol>');
    var fList20951 = opt_data.fulfillments;
    var fListLen20951 = fList20951.length;
    for (var fIndex20951 = 0; fIndex20951 < fListLen20951; fIndex20951++) {
      var fData20951 = fList20951[fIndex20951];
      output.append('<li class="el8BulletText">');
      el8.template.ptdata.model.medOrder.fulfillment(soy.$$augmentData(fData20951, {showBadges: opt_data.showBadges}), output);
      output.append('</li>');
    }
    output.append('</ol>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.fulfillment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.type == 'surescripts_cancel') {
    el8.template.ptdata.model.medOrder.fulfillmentCancel(opt_data, output);
  } else if (opt_data.type == 'surescripts_change') {
    el8.template.ptdata.model.medOrder.fulfillmentChange(opt_data, output);
    output.append((! opt_data.isLinkedToChangeRequest) ? '<p class="el8AppText">NOTICE: Your practice has sent multiple responses to the pharmacy’s request to change the prescription. Please contact the pharmacy directly to confirm what has been dispensed.</p>' : '');
  } else if (opt_data.isError) {
    output.append('<div class="el8AttentionTagItem padv5h10"><p class="el8AttentionText">');
    if (opt_data.isFailedMissingDeaSchedule) {
      output.append('State specific controlled substances cannot be e-prescribed at this time. Please print or fax the medication.');
    } else {
      if (opt_data.detail) {
        output.append(soy.$$escapeHtml(opt_data.detail));
      } else {
        output.append('Prescription not received');
        el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data, {preposition: 'by'}), output);
      }
      output.append('.');
    }
    output.append('</p></div>');
  } else if (opt_data.state == 'sending') {
    output.append('<p class="el8AppText">Being sent');
    el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data, {preposition: 'to'}), output);
    output.append('...</p>');
  } else if (opt_data.isSuccess) {
    if (opt_data.type == 'paper') {
      output.append('<p class="el8AppText">Printed on ', (soy.$$escapeHtml(opt_data.timeCompleted)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.timeCompleted)) : ''), '.</p>');
    } else if (opt_data.type == 'fax') {
      output.append('<p class="el8AppText">Faxed');
      el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data, {preposition: 'to'}), output);
      output.append(' on ', (soy.$$escapeHtml(opt_data.timeCompleted)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.timeCompleted)) : ''), '.</p>');
    } else if (opt_data.type == 'phone') {
      output.append('<p class="el8AppText">Called in');
      el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data, {preposition: 'to'}), output);
      output.append(' on ', (soy.$$escapeHtml(opt_data.timeCompleted)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.timeCompleted)) : ''), '.</p>');
    } else {
      output.append('<p class="el8AppText">Sent');
      el8.template.ptdata.model.medOrder.pharmacyInfo(soy.$$augmentData(opt_data, {preposition: 'to'}), output);
      output.append(' on ', (soy.$$escapeHtml(opt_data.timeCompleted)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.timeCompleted)) : ''), '.', (opt_data.state == 'complete') ? '<a class="explain-surescripts-trigger">*</a>' : '', '</p>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.fulfillmentCancel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.isPending) {
    output.append('<p class="el8AppText">', (opt_data.showBadges) ? '<span class="el8TagItem mr5 ' + ((opt_data.isCancelIgnored) ? 'el8MakeTagFinished' : 'el8MakeTagInProgress') + '">' + ((opt_data.isCancelIgnored) ? 'Cancellation requested, no response' : (opt_data.isSent) ? 'Cancellation sent to pharmacy' : 'Canceling...') + '</span><span style="font-size: 0">&nbsp;</span>' : '', (opt_data.isCancelIgnored) ? 'Message to cancel eRx has been submitted to the pharmacy. Cancellation request response not received within 24 hours.' : 'Message to cancel eRx has been submitted to the pharmacy. Cancellation expected within 12 hours.', '</p>');
  } else if (opt_data.isSuccess) {
    output.append('<p class="el8AppText">', (opt_data.showBadges) ? '<span class="el8TagItem el8MakeTagFinished mr5">Canceled</span><span style="font-size: 0">&nbsp;</span>' : '', 'This eRx order ', (opt_data.pharmacy) ? 'to ' + soy.$$escapeHtml(opt_data.pharmacy.name) + ' ' : '', 'was canceled on ', (soy.$$escapeHtml(opt_data.cancelTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.cancelTime)) : ''), ' by ', soy.$$escapeHtml(opt_data.cancelUserName), (opt_data.cancelNoteFromPharmacy) ? ' Note from pharmacy: "' + soy.$$escapeHtml(opt_data.cancelNoteFromPharmacy) + '"' : '', '</p>');
  } else if ((opt_data.isError || opt_data.isDenied) && opt_data.isDismissed) {
    output.append('<p class="el8AppText">');
    el8.template.ptdata.model.medOrder.fulfillmentDenialText(opt_data, output);
    output.append('</p>');
  } else if (opt_data.isError || opt_data.isDenied) {
    output.append('<div class="el8AttentionTagItem padv5h10"><p class="el8AppText el8AttentionText">');
    el8.template.ptdata.model.medOrder.fulfillmentDenialText(opt_data, output);
    output.append('</p></div>');
  }
  output.append((opt_data.requestingUserReason) ? '<p class="el8AppText">Reason for cancellation: ' + soy.$$escapeHtml(opt_data.requestingUserReason) + '</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.fulfillmentDenialText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('The pharmacy was unable to cancel this eRx order as you requested. ', soy.$$escapeHtml(opt_data.cancelResponseReason), '<br />Please follow up with the pharmacy directly.', (opt_data.cancelNoteFromPharmacy) ? ' Note from pharmacy: "' + soy.$$escapeHtml(opt_data.cancelNoteFromPharmacy) + '"' : '', (opt_data.cancelResponseTime) ? ' (' + (soy.$$escapeHtml(opt_data.cancelResponseTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.cancelResponseTime)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.fulfillmentChange = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.changeRequestType == 'P') {
    output.append((opt_data.isSuccess) ? '<p class="el8AppText">Informed pharmacy on ' + (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.changeResponseTime)) : '') + ' that prior authorization was obtained for this prescription.' + ((opt_data.changeResponsePriorAuthNum) ? ' Prior authorization number: ' + soy.$$escapeHtml(opt_data.changeResponsePriorAuthNum) : '') + '</p>' : (opt_data.changeResponseReasonCode == 'payer_not_contacted') ? '<p class="el8AppText">Informed pharmacy on ' + (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.changeResponseTime)) : '') + ' that payer was not contacted regarding prior authorization for this prescription.' + ((opt_data.changeResponseReason) ? 'Note to pharmacy: "' + soy.$$escapeHtml(opt_data.changeResponseReason) + '"' : '') + '</p>' : (opt_data.changeResponseReasonCode == 'payer_denied') ? '<p class="el8AppText">Informed pharmacy on ' + (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.changeResponseTime)) : '') + ' denied prior authorization for this prescription.' + ((opt_data.changeResponseReason) ? 'Note to pharmacy: "' + soy.$$escapeHtml(opt_data.changeResponseReason) + '"' : '') + '</p>' : '');
  } else if (opt_data.isSuccess && opt_data.changeResponse == 'approved_modified') {
    output.append('<p class="el8AppText">', (opt_data.showBadges) ? '<span class="el8TagItem mr5">Changed per pharmacy</span><span style="font-size: 0">&nbsp;</span>' : '', 'Pharmacy requested change from "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.prescribedPrescription, output);
    output.append('" to "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.changeRequested, output);
    output.append('", approved with modifications by ', soy.$$escapeHtml(opt_data.changeResponseUserName), ' on ', (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.changeResponseTime)) : ''), '.</p>');
  } else if (opt_data.isSuccess && opt_data.changeResponse == 'denied') {
    output.append('<p class="el8AppText">Request from pharmacy to change this eRx order to "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.changeRequested, output);
    output.append('" was denied by ', soy.$$escapeHtml(opt_data.changeResponseUserName), ' on ', (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.changeResponseTime)) : ''), '. Denial reason: ', soy.$$escapeHtml(opt_data.changeResponseReason), '</p>');
  } else if (opt_data.isSuccess) {
    output.append('<p class="el8AppText">', (opt_data.showBadges) ? '<span class="el8TagItem mr5">Changed per pharmacy</span><span style="font-size: 0">&nbsp;</span>' : '', 'Pharmacy requested change from "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.prescribedPrescription, output);
    output.append('" to "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.changeRequested, output);
    output.append('", approved by ', soy.$$escapeHtml(opt_data.changeResponseUserName), ' on ', (soy.$$escapeHtml(opt_data.changeResponseTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.changeResponseTime)) : ''), '.</p>');
  } else if (opt_data.isError) {
    output.append('<div class="el8AttentionTagItem padv5h10"><p class="el8AttentionText">Change request response failed to send to pharmacy. Pharmacy did not receive request to change this eRx order to "');
    el8.template.ptdata.model.medOrder.requestedPrescriptionChange(opt_data.changeRequested, output);
    output.append('".</p>', (opt_data.detail) ? '<p class="el8AttentionText">' + soy.$$escapeHtml(opt_data.detail) + '</p>' : '', '</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.requestedPrescriptionChange = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.baseSummary({displayedMedicationName: opt_data.displayed_medication_name, directions: opt_data.directions, quantity: opt_data.quantity, quantityUnits: opt_data.quantity_units, authRefills: opt_data.auth_refills}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.pharmacyInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.pharmacy) ? ((opt_data.pharmacy.name) ? ' ' + soy.$$escapeHtml(opt_data.preposition) + ' ' + soy.$$escapeHtml(opt_data.pharmacy.name) : '') + ((opt_data.pharmacy.addressLine && opt_data.pharmacy.cityState) ? ' (' + soy.$$escapeHtml(opt_data.pharmacy.addressLine) + ', ' + soy.$$escapeHtml(opt_data.pharmacy.cityState) + ((opt_data.pharmacy.phone) ? ', T: ' + soy.$$escapeHtml(opt_data.pharmacy.phone) : '') + ')' : (opt_data.pharmacy.phone) ? ' (T: ' + soy.$$escapeHtml(opt_data.pharmacy.phone) + ')' : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.ownedDocSummaryType = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.typeSummary(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.ownedDocSummaryDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.baseSummary(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.ownedDocSummaryInstr = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.pharmacyInstructionsSummary(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.ownedDocSummaryOtherPrescriber = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.medOrder.otherPrescriberSummary(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.medOrder.ownedDocSummaryStartDate = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((! opt_data.includeStartDate && opt_data.isPostDated) ? ' (to start on: ' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') + ')' : (opt_data.includeStartDate) ? ' (start on: ' + (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};
